<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações da Expedição</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()" [matTooltip]="tooltipVoltar"
            [attr.aria-label]="tooltipVoltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Defina as regras de conferência, postagem, notificações e impressão do despacho dos pedidos.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="50%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="240" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="60%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="200" width="100%" marginTop="8"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="160" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        @if (!isTrabalhaComExpedicao) {
          <div class="conteudo-secao mt-3">
            <app-alert-card type="warning">
              A empresa não trabalha com expedição. Estas configurações só passam a valer quando "Trabalha com
              Expedição" for ativado em Configurações Gerais de Vendas.
            </app-alert-card>
          </div>
        }

        <!-- ================= Valor e conferência ================= -->
        <div class="section-container" id="valor-conferencia">
          <div class="section-title">
            <mat-icon>fact_check</mat-icon>
            <span>Valor e conferência</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isMostrarValorMercadoria">Mostrar valor das
                  mercadorias</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isHabilitarConferenciaPedido">Habilitar
                  conferência de pedidos na expedição</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirPedidoCanceladoListaColeta">Imprimir
                  pedidos cancelados na lista de coleta</mat-slide-toggle>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Postagem e valor declarado ================= -->
        <div class="section-container mt-4" id="postagem-valor-declarado">
          <div class="section-title">
            <mat-icon>local_post_office</mat-icon>
            <span>Postagem e valor declarado</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <label class="bloco-titulo">Valor declarado ao enviar para a expedição</label>
              <mat-radio-group formControlName="idTipoValorDeclaradoExpedicao" class="radio-grupo-coluna">
                @for (t of opcoesTipoValorDeclaradoExpedicao; track t.idTipoValorDeclaradoExpedicao) {
                  <mat-radio-button [value]="t.idTipoValorDeclaradoExpedicao">{{ t.descricao }}</mat-radio-button>
                }
              </mat-radio-group>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <div class="toggle-content">
                  <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirValorDeclaradoEtiqueta">Imprimir
                    valor declarado nas etiquetas</mat-slide-toggle>
                </div>
                @if (isSemValorDeclarado) {
                  <app-alert-card type="info">
                    Sem efeito enquanto "Valor declarado ao enviar para a expedição" estiver como "Sem valor declarado".
                  </app-alert-card>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Notificações por e-mail ================= -->
        <div class="section-container mt-4" id="notificacoes-email">
          <div class="section-title">
            <mat-icon>mail</mat-icon>
            <span>Notificações por e-mail</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            @for (bloco of blocosEmail; track bloco.controleEnvio; let primeiro = $first) {
              <div class="col-12">
                <div [class.bloco-separado]="!primeiro">
                  <label class="bloco-titulo">{{ bloco.titulo }}</label>

                  <div class="toggle-content">
                    <mat-slide-toggle class="app-toggle-compact" [formControlName]="bloco.controleEnvio">{{ bloco.rotuloEnvio
                      }}</mat-slide-toggle>
                  </div>

                  <mat-form-field appearance="outline" class="w-100 mt-2">
                    <mat-label>Assunto padrão</mat-label>
                    <input matInput [formControlName]="bloco.controleAssunto" maxlength="255">
                    @if (form.get(bloco.controleAssunto)?.hasError('required')) {
                      <mat-error>Informe o assunto padrão</mat-error>
                    }
                  </mat-form-field>

                  <label class="rotulo-editor">Mensagem padrão</label>
                  <div class="editor-container">
                    <ngx-editor-menu [editor]="bloco.editor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="bloco.editor" [formControlName]="bloco.controleMensagem"
                      placeholder="Escreva a mensagem..."></ngx-editor>
                  </div>

                  <a class="variaveis-link" (click)="alternarVariaveis(bloco)">
                    <mat-icon class="variaveis-icon">swap_horiz</mat-icon>
                    {{ bloco.exibirVariaveis ? 'Ocultar variáveis disponíveis' : 'Exibir variáveis disponíveis' }}
                  </a>
                  @if (bloco.exibirVariaveis) {
                    <app-alert-card type="info">
                      <strong>Variáveis disponíveis para uso na mensagem:</strong>
                      <ul class="variaveis-list mt-2 mb-0">
                        @for (variavel of bloco.variaveis; track variavel.codigo) {
                          <li>
                            <button mat-button type="button" class="variavel-button"
                              (click)="inserirVariavel(bloco, variavel.codigo)">
                              <code>{{ variavel.codigo }}</code>
                            </button>
                            <span>{{ variavel.descricao }}</span>
                          </li>
                        }
                      </ul>
                    </app-alert-card>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        <!-- ================= Impressão ================= -->
        <div class="section-container mt-4" id="impressao">
          <div class="section-title">
            <mat-icon>print</mat-icon>
            <span>Impressão</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12 col-md-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Imprimir automaticamente ao finalizar expedição</mat-label>
                <mat-select formControlName="listTipoDocumentoImpressao" [multiple]="true" placeholder="Não imprimir">
                  <mat-select-trigger>{{ resumoImpressaoAutomatica }}</mat-select-trigger>
                  @for (doc of opcoesTipoDocumentoImpressao; track doc.idTipoDocumentoImpressao) {
                    <mat-option [value]="doc.idTipoDocumentoImpressao">{{ doc.descricao }}</mat-option>
                  }
                </mat-select>
                <mat-hint>A impressão automática de DANFE depende de existir nota fiscal autorizada para os pedidos da
                  expedição.</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading || !configCarregada"
  (cancelar)="voltar()" (salvar)="salvar()">
</app-footer-action>
